import type {ReactElement} from 'react';
import {NewSubscriberNotificationToggleControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/new-subscriber-notification-toggle-control/new-subscriber-notification-toggle-control';
import {SignupOnly} from '@FormMakerReact/layout/form-maker-right-panel/components/signup-only/signup-only';
import type {FormBackgroundNotificationToggleControlProps} from './form-background-notification-toggle-control.types';

export function FormBackgroundNotificationToggleControl({component}: FormBackgroundNotificationToggleControlProps): ReactElement | null {
  return (
    <SignupOnly component={component}>
      <NewSubscriberNotificationToggleControl />
    </SignupOnly>
  );
}
